module.exports = __webpack_public_path__ + "static/media/signal-2.ee8a0315.svg";